
import { Component, Mixins, Watch } from 'vue-property-decorator';
import Content from '@/features/dashboard/components/widgets/topDestinations/Content.vue';
import PieChartSkeleton from '@/features/dashboard/components/widgets/PieChartSkeleton.vue';
import { getTopDestinationsData } from '@/features/dashboard/services/dashboard.services';
import { periodItems, PeriodItemValueType } from '@/features/common/raw';
import { getLastDateRangeFromToday } from '@/features/common/helpers/moment';
import { TopDestinationsWidget } from '@/features/dashboard/types';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { WidgetMixin } from '../widgetMixin';

@Component({
  components: {
    Content,
    PieChartSkeleton,
  },
})
export default class TopDestinations extends Mixins(WidgetMixin) {
  private destinationsShown = 3;

  private destinationsShownItems: Array<number> = [3, 5, 7, 9, 12];

  private periodItems = periodItems;

  private period: PeriodItemValueType = 'Last30Days';

  private periodTemp: PeriodItemValueType = this.period;

  private periodFromRangePicker: {
    fromDate: string,
    toDate: string
  } = getLastDateRangeFromToday('Last30Days');

  private isLoading = true;

  get widget(): TopDestinationsWidget {
    return this.$store.getters.getWidgets.topDestinations;
  }

  get isDashboardSettingsLoaded(): number {
    return this.$store.getters.getIsDashboardSettings;
  }

  @Watch('isDashboardSettingsLoaded', { immediate: true })
  private loadTopDestinationsData(newValue: number) {
    if (!newValue) return;

    this.destinationsShown = (this.widget.itemsShown || 3) as number;
    if (this.widget.customSettings && this.widget.customSettings.range) {
      this.period = this.widget.customSettings.range;
      this.periodTemp = this.period;
      this.periodFromRangePicker = getLastDateRangeFromToday(this.period);
    }
    this.updateWidgetData();
  }

  private async updateWidgetData(): Promise<void> {
    this.isLoading = true;
    this.rerenderWidget();

    const topDestinationsData = await getTopDestinationsData(
      this.periodFromRangePicker.fromDate,
      this.periodFromRangePicker.toDate,
      this.destinationsShown,
    );
    this.$store.commit('setTopDestinations', topDestinationsData);

    this.isLoading = false;
    this.rerenderWidget();
    eventBus.$emit(eventNames.DASHBOARD_WIDGET_DATA_LOADED);
  }

  private updateDateRange(period: { fromDate: string, toDate: string}) {
    this.periodFromRangePicker = period;
    this.periodTemp = this.period;
    this.updateWidgetData();
  }

  private handleApply(widgetName: string) {
    this.period = this.periodTemp;

    this.apply('small');

    this.$store.dispatch('syncDashboardSetting', {
      dashboardWidget: widgetName,
      visible: true,
      position: this.currentPosition,
      itemsShown: this.destinationsShown,
      customSettings: {
        range: this.period,
        fromDate: this.periodFromRangePicker.fromDate,
        toDate: this.periodFromRangePicker.toDate,
      },
    });

    if (this.position !== this.currentPosition) {
      this.$store.dispatch('patchDashboardSetting', { size: 'small' });
      eventBus.$emit(eventNames.SORT_DASHBOARD_WIDGETS_POSITION, 'small');
    }

    this.updateWidgetData();
  }

  private onChangePeriod(period: { fromDate: string, toDate: string}, value: PeriodItemValueType) {
    this.periodFromRangePicker = period;
    this.periodTemp = value;
  }
}
